export const fleet = state => state.drivers
export const fleetDrivers = state => state.drivers.filter(driver => { return driver.fleet_driver && driver.business_driver })
export const activefleetdriverscount = state => state.drivers.filter(driver => { return driver.fleet_driver && driver.business_driver }).length
export const allfleetdriverscount = state => state.drivers.filter(driver => { return driver.fleet_driver }).length
export const allFleetDrivers = state => state.drivers.filter(driver => { return driver.fleet_driver })
export const getDriver = state => driverId => {
	return state.drivers.find(driver => driver.id === driverId)
}
